// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.D2QBxh {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  background: var(--background-alt);
  gap: var(--spacing-3);
}

.IhHMcj {
  display: flex;
  align-items: flex-start;
  gap: var(--spacing-3);
  width: 100%;
}

.jUgX3q {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

@media (max-width: 1024px) {
  .IhHMcj {
    flex-direction: column;
  }
}

@media (max-width: 768px) {
  .D2QBxh {
    padding: var(--spacing-2);
    gap: var(--spacing-2);
  }

  .IhHMcj {
    gap: var(--spacing-2);
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/pages/ToReceive/ToReceive.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,aAAa;EACb,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,aAAa;AACf;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;AACF","sourcesContent":[".main {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  background: var(--background-alt);\n  gap: var(--spacing-3);\n}\n\n.actionCardsRow {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--spacing-3);\n  width: 100%;\n}\n\n.chargesTableSection {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n}\n\n@media (max-width: 1024px) {\n  .actionCardsRow {\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 768px) {\n  .main {\n    padding: var(--spacing-2);\n    gap: var(--spacing-2);\n  }\n\n  .actionCardsRow {\n    gap: var(--spacing-2);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `D2QBxh`,
	"actionCardsRow": `IhHMcj`,
	"chargesTableSection": `jUgX3q`
};
module.exports = ___CSS_LOADER_EXPORT___;
